import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

interface CTASectionProps {
  industryName: string;
  onRequestDemo: () => void;
  onContactSales: () => void;
}

const CTASection = ({ industryName, onRequestDemo, onContactSales }: CTASectionProps) => {
  return (
    <section className="py-16 bg-gradient-to-br from-primary to-secondary relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to Transform Your {industryName} Operations?
        </h2>
        <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
          Join leading organizations leveraging AI-powered analytics to drive measurable business results
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="secondary"
            size="lg"
            iconName="Play"
            iconPosition="left"
            onClick={onRequestDemo}
            className="bg-white text-primary hover:bg-white/90"
          >
            Request Live Demo
          </Button>
          <Button
            variant="outline"
            size="lg"
            iconName="MessageSquare"
            iconPosition="left"
            onClick={onContactSales}
            className="border-white text-white hover:bg-white/10"
          >
            Contact Sales Team
          </Button>
        </div>
        
        <div className="mt-12 grid sm:grid-cols-3 gap-6 text-white">
          <div className="flex flex-col items-center">
            <Icon name="Users" size={32} className="mb-3" />
            <div className="text-2xl font-bold mb-1">500+</div>
            <div className="text-sm text-white/80">Enterprise Clients</div>
          </div>
          <div className="flex flex-col items-center">
            <Icon name="Award" size={32} className="mb-3" />
            <div className="text-2xl font-bold mb-1">98%</div>
            <div className="text-sm text-white/80">Customer Satisfaction</div>
          </div>
          <div className="flex flex-col items-center">
            <Icon name="TrendingUp" size={32} className="mb-3" />
            <div className="text-2xl font-bold mb-1">3.5x</div>
            <div className="text-sm text-white/80">Average ROI</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;